import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, setAuthToken } from '@/lib/api';
import { ADMIN } from '@/constants/testIds';
import { motion } from 'framer-motion';

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const { data } = await api.post('/admin/login', { email: email.trim().toLowerCase(), password });
      setAuthToken(data.token);
      navigate('/admin');
    } catch (e) {
      setError(e?.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-12">
      <motion.form
        onSubmit={onSubmit}
        initial={{ opacity: 1, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}
        className="pg-card p-8 sm:p-10 w-full max-w-md"
      >
        <p className="pg-label">Caretaker access</p>
        <h1 className="font-serif text-3xl mt-3 text-[var(--pg-ink)]">Enter the back room.</h1>
        <p className="text-sm text-[var(--pg-ink-muted)] mt-2">Only the keeper of Planet G should be here.</p>

        <div className="mt-6 space-y-4">
          <div>
            <label className="text-xs font-mono tracking-widest text-[var(--pg-ink-muted)]">EMAIL</label>
            <input
              data-testid={ADMIN.emailInput}
              type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              required disabled={loading}
              className="mt-1 w-full pg-input rounded-[var(--pg-radius-sm)] px-3 py-2.5 text-sm"
            />
          </div>
          <div>
            <label className="text-xs font-mono tracking-widest text-[var(--pg-ink-muted)]">PASSWORD</label>
            <input
              data-testid={ADMIN.passwordInput}
              type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              required disabled={loading}
              className="mt-1 w-full pg-input rounded-[var(--pg-radius-sm)] px-3 py-2.5 text-sm"
            />
          </div>
        </div>

        {error && <p className="mt-4 text-xs font-mono text-[var(--pg-neon-pink)]">{error}</p>}

        <button
          data-testid={ADMIN.submit}
          type="submit" disabled={loading}
          className="mt-6 w-full pg-btn-primary rounded-[var(--pg-radius-md)] py-3 text-sm font-medium disabled:opacity-60"
        >
          {loading ? 'Entering…' : 'ENTER'}
        </button>
      </motion.form>
    </div>
  );
}
